import { Pipe, PipeTransform } from '@angular/core';
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import json from 'highlight.js/lib/languages/json';
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('JSON', json);

@Pipe({ name: 'sbCode' })
export class SbCodePipe implements PipeTransform {
  public transform(code: string, language: string): any {
    try {
      return typeof code === 'string' && code.length > 0 && language
        ? hljs.highlight(language, code).value
        : '';
    } catch (e) {
      return code.replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;');
    }
  }
}
